import React from "react";
import { Link } from "react-router-dom";

const AddressCard = ({ item }) => {
  //console.log(item);
  return (
    <div className="col-md-4 mt-3" key={item.id}>
      <div className="card mb-4 product-wap rounded-0">
        <div className="card rounded-0">
          <div className="p-3 mb-2 bg-secondary text-white">{item?.address_type}</div>
          <div className="card-body">
            <p className="card-text">{item?.address1}<br/>
            {item?.address2}<br/>
            {item?.city}, {item?.state}<br/>
            {item?.pincode}</p>
          </div>
          <div className="col d-grid"><Link className="btn btn-success btn-lg text-decoration-none text-dark" 
            to={`/user-addresses/${item.id}`}>Update Address</Link></div>
        </div>
      </div>
    </div>
  );
};

export default AddressCard;
